export default __webpack_public_path__ + "static/media/13.5ec4d64a.PNG";